import React from "react";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./AsideTooltip.module.css";

interface Props {
  heading: string;
  text: string;
  footerComponent?: React.ReactNode;
}

const AsideTooltip: React.FC<Props> = ({ heading, text, footerComponent }) => {
  return (
    <div className={styles.container}>
      <Text variant={"heading1"} color={"text"}>
        {heading}
      </Text>

      <Text variant={"body"} color={"textSubtle"}>
        {text}
      </Text>

      {footerComponent}
    </div>
  );
};

export default AsideTooltip;
